import { render, staticRenderFns } from "./workTaskPop.vue?vue&type=template&id=48bff7c5&scoped=true&"
import script from "./workTaskPop.vue?vue&type=script&lang=js&"
export * from "./workTaskPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bff7c5",
  null
  
)

export default component.exports